'use client';

import { Suspense } from 'react';
import dynamic from 'next/dynamic';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuthMe } from '@/features/user';
import QueryProvider from '@/providers/query-provider';
import { ModalProvider } from '@/providers/modal-provider';
import {
  NestedModalProvider,
  TOAST_CONTAINER_Z_INDEX,
} from '@/providers/nested-modal-provider';
import ProgressBar from '@/components/common/ProgressBar';
import { isChristmasPeriod } from '@/lib/utils/dateUtils';

// Not needed for first paint (admin-only widget / seasonal effect): load lazily.
const QuickSearch = dynamic(
  () => import('@/components/common/admin/QuickSearch'),
  { ssr: false }
);
const ChristmasEffects = dynamic(
  () => import('@/components/ui/ChristmasEffects'),
  { ssr: false }
);

function AuthSessionBootstrap({ children }: { children: React.ReactNode }) {
  useAuthMe();
  return children;
}

export default function AppProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <QueryProvider>
      <AuthSessionBootstrap>
        <ModalProvider>
          <NestedModalProvider>
            {isChristmasPeriod() && <ChristmasEffects />}
            <ProgressBar />
            <Suspense>{children}</Suspense>
            <QuickSearch />
            <ToastContainer
              autoClose={2000}
              closeOnClick
              theme="colored"
              style={{ zIndex: TOAST_CONTAINER_Z_INDEX }}
            />
          </NestedModalProvider>
        </ModalProvider>
      </AuthSessionBootstrap>
    </QueryProvider>
  );
}
